var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("modal-dialog", {
    attrs: {
      id: _vm.popinId,
      "modal-button-label": "Fermer",
      "action-label": "Ouvrir",
      "modal-title": _vm.title,
    },
    scopedSlots: _vm._u([
      {
        key: "modalBody",
        fn: function () {
          return [
            _vm.visual
              ? _c("div", { staticClass: "text-center" }, [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: { src: _vm.visual.url, alt: _vm.visual.alt || "" },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.sections, function (section) {
              return [
                section.title
                  ? _c("h4", {
                      staticClass: "lead m-0 p-0",
                      domProps: { innerHTML: _vm._s(section.title) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                section.icon
                  ? _c("div", { staticClass: "col-12 d-flex" }, [
                      _c("span", {
                        staticClass: "icon h1 align-self-center text-primary3",
                        class: section.icon,
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "ms-1",
                        domProps: { innerHTML: _vm._s(section.paragraph) },
                      }),
                    ])
                  : _c("div", { staticClass: "col-12 d-flex" }, [
                      _c("p", {
                        domProps: { innerHTML: _vm._s(section.paragraph) },
                      }),
                    ]),
              ]
            }),
            _vm._v(" "),
            _vm.mentions
              ? _c("p", {
                  staticClass: "font-size-12",
                  domProps: { innerHTML: _vm._s(_vm.mentions) },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }